declare const __APP_VERSION__: string;

export const APP_VERSION: string = (() => {
  try {
    return __APP_VERSION__;
  } catch {
    return 'dev';
  }
})();
